import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-better-together-apple',
  templateUrl: './better-together-apple.component.html',
  styleUrls: ['./better-together-apple.component.css']
})
export class BetterTogetherAppleComponent implements OnInit, AfterViewInit, OnDestroy {

  hidden = true;

  formName = '';
  formSchool = '';
  formEmail = '';
  formCountry = '';
  formSubmitted = false;

  books = [
    '../../../../assets/books/Book-1-no-title.png',
    '../../../../assets/books/Book-2-no-title.png',
    '../../../../assets/books/Book-3-no-title.png',
    '../../../../assets/books/Book-4-no-title.png',
    '../../../../assets/books/Book-5-no-title.png',
  ];
  bookIndex = 0;
  private bookInterval: any;

  monitorIndex = 0;
  private monitorInterval: any;

  mathQuestions = [
    '24 ÷ 6 = ?', '7 × 8 = ?', '144 ÷ 12 = ?', '15 + 27 = ?',
    '63 − 28 = ?', '9 × 7 = ?', '48 ÷ 4 = ?', '36 + 45 = ?',
    '121 ÷ 11 = ?', '6² = ?', '3 × 14 = ?', '100 − 37 = ?',
  ];
  currentMathQuestion = this.mathQuestions[0];
  questionFading = false;
  private mathInterval: any;

  constructor(private titleSv: Title) {
    this.titleSv.setTitle('Better Together — Evolytes & Apple Education');
  }

  ngOnInit() {
    this.startMathCycle();
    this.startBookCycle();
    this.startMonitorCycle();
  }

  ngAfterViewInit() {
    this.initScrollAnimations();
  }

  setHidden() {
    this.hidden = !this.hidden;
  }

  submitDemoForm() {
    if (!this.formName || !this.formEmail) { return; }
    const mailto = `mailto:schools@evolytes.com?subject=Demo Request from ${encodeURIComponent(this.formName)}&body=${encodeURIComponent(
      `Name: ${this.formName}\nSchool: ${this.formSchool}\nEmail: ${this.formEmail}\nCountry: ${this.formCountry}`
    )}`;
    window.location.href = mailto;
    this.formSubmitted = true;
  }

  ngOnDestroy() {
    if (this.mathInterval) clearInterval(this.mathInterval);
    if (this.bookInterval) clearInterval(this.bookInterval);
    if (this.monitorInterval) clearInterval(this.monitorInterval);
  }

  getBookPos(i: number): number {
    return (i - this.bookIndex + this.books.length) % this.books.length;
  }

  private startBookCycle() {
    this.bookInterval = setInterval(() => {
      this.bookIndex = (this.bookIndex + 1) % this.books.length;
    }, 3300);
  }

  private startMonitorCycle() {
    this.monitorInterval = setInterval(() => {
      this.monitorIndex = this.monitorIndex === 0 ? 1 : 0;
    }, 4500);
  }

  private startMathCycle() {
    let i = 0;
    this.mathInterval = setInterval(() => {
      this.questionFading = true;
      setTimeout(() => {
        i = (i + 1) % this.mathQuestions.length;
        this.currentMathQuestion = this.mathQuestions[i];
        this.questionFading = false;
      }, 300);
    }, 2500);
  }

  private initScrollAnimations() {
    const elements = document.querySelectorAll('.fade-up');
    if (!elements.length) { return; }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    elements.forEach(el => observer.observe(el));
  }
}
